export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_MAX_STEP = "UPDATE_MAX_STEP";
export const UPDATE_CURRENT_STEP = "UPDATE_CURRENT_STEP";
export const UPDATE_STATUS_STATE = "UPDATE_STATUS_STATE";

export function updateOrderState(data) {
  return {
    type: UPDATE_ORDER,
    data
  };
}

export function updateMaxStep(step) {
  return {
    type: UPDATE_MAX_STEP,
    step
  };
}

export function updateCurrentStep(step) {
  return {
    type: UPDATE_CURRENT_STEP,
    step
  };
}

export function updateStatusState(status) {
  return {
    type: UPDATE_STATUS_STATE,
    status
  };
}
